<footer>
  <div class="firstCol">
    <p>
      &copy; {{currentYear}}
      <a href="https://www.msystechnologies.com/" target="_blank">Aziro Technologies</a>
    </p>
    @if (user.userDetails.email == 'playstoreaccess50@gmail.com') {
      <p>
        <a href="/delete-user">Raise Request</a>
      </p>
    }
  </div>
  <div class="secondCol">
    <a routerLink="privacy-setting/privacy" routerLinkActive #privacy="routerLinkActive"
      [ngClass]="privacy.isActive ? 'activeClass' : ''">
      Privacy Policy
    </a>
    <!-- <p routerLink="settings/terms">Terms Of Use</p> -->
    @if (user.userDetails.role == 'superadmin') {
      <a routerLink="privacy-setting/change-logs" routerLinkActive
        #logs="routerLinkActive" [ngClass]="logs.isActive ? 'activeClass' : ''">
        Change Logs
      </a>
    }
    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.acplAmazon.FingerMatch"
      style="cursor: pointer">
      <img style="width: 90px" src="../../../assets/images/googleplay.svg" />
    </a>
  </div>
</footer>